import { useRouteError } from 'react-router';

import logger from '../logger/logger';

import { ErrorBoundary } from './ErrorBoundary';

type ErrorObject = Error & {
  status: number;
  graphQLErrors: unknown[];
  networkError: {
    result: unknown[];
  };
};

export function ErrorBoundaryContainer() {
  const error = useRouteError() as ErrorObject;

  const routeError = {
    ...error,
    graphQLErrorsStringified: JSON.stringify(error.graphQLErrors || []),
    networkError: {
      ...error.networkError,
      result: JSON.stringify(error.networkError?.result || []),
    },
  };

  // If its a 404 error, we don't want to log it as an error
  if (error.status === 404) {
    logger.warn(
      'ErrorBoundary',
      'ErrorBoundary caught a 404 error',
      routeError,
    );
  } else {
    logger.error(
      'ErrorBoundary',
      'ErrorBoundary caught a 404 error',
      routeError,
    );
  }

  return <ErrorBoundary />;
}
